import { render, staticRenderFns } from "./TranslationModal.vue?vue&type=template&id=1e2ad5d0"
import script from "./TranslationModal.vue?vue&type=script&lang=js"
export * from "./TranslationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports